import { AppHelper } from "../appHelper"
import { Grid } from "../core/components/grid";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Region } from "../core/components/region";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class ActionLocksApp extends React.Component<AppBaseProps, ActionLocksAppState> {
    private actionLocksGridData: Array<any> = [];
    private actionLocksAktionTypesData: Array<any> = [];
    private kennungTypesData: Array<any> = [];
    private grNrData: Array<any> = [];
    private ogrNrData: Array<any> = [];
    private knrData: Array<any> = [];
    private actionLocksRightsGridData: Array<any> = [];
    private actionLocksGridRef: Grid;
    private actionLocksRightsGridRef: Grid;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string>;
    actionLocksGridOptions: kendo.ui.GridOptions;
    actionLocksRightsGridOptions: kendo.ui.GridOptions;
    resetSelectionRights: boolean;

    constructor(props: AppBaseProps) {
        super(props);
        this.resetSelectionRights = false;
        this.state = { selectedActionId: null, selectedActionRightsId: null }
        this.common.enableHooks = true;
        this.common.init(this);
        this.load().then(() => {});
    }
    
    private load = async () => {
        const result = await HTTPService.chainBatch
            .add("ActionLocks/GetActionLockTypes")
            .add("ActionLocks/GetActionLocksGridData")
            .add("ActionLocks/GetKennungsTypes")
            .add("ActionLocks/GetGroups")
            .add("ActionLocks/GetMainGroups")
            .add("ActionLocks/GetKNrTypes")
            .promise();
        
        Helper.setArrayValues(this.actionLocksAktionTypesData, result[0]);
        Helper.setArrayValues(this.actionLocksGridData, result[1]);
        Helper.setArrayValues(this.kennungTypesData, result[2]);
        Helper.setArrayValues(this.grNrData, result[3]);
        Helper.setArrayValues(this.ogrNrData, result[4]);
        Helper.setArrayValues(this.knrData, result[5]);
        this.updateLocksDataArray();

        this.setState({ selectedActionRightsId: null, selectedActionId: null });
    }

    private refresh = async () => {
        const result =  await HTTPService.get("ActionLocks/GetActionLocksGridData");
        Helper.setArrayValues(this.actionLocksGridData, result);
        this.updateLocksDataArray();
    }
    
    
    private updateLocksDataArray() {
        this.actionLocksGridData.forEach(item => {
            item["AktionText"] = this.actionLocksAktionTypesData.find(t => t.Value === item["Aktion"]).Text;
            item["KennungstypText"] = this.kennungTypesData.find(t => t.Value === item["Kennungstyp"]).Text;
            item["GrNrText"] = this.grNrData.find(t => t.Value === item["GrNr"]).Text;
            item["OgrNrText"] = this.ogrNrData.find(t => t.Value === item["OgrNr"]).Text;
            item["KNrText"] = this.knrData.find(t => t.Value === item["KNr"]).Text;
            if (item["Offset"] == null)
                item["Offset"] = 0;
        });
    }

    private getActionLocksRightsGridData = async (selectedActionId) => {
        const result =  await HTTPService.get("ActionLocks/GetActionLocksRightsGridData?id=" + selectedActionId);
        Helper.setArrayValues(this.actionLocksRightsGridData, result);
        this.updateLocksRightsDataArray();
    }

    private updateLocksRightsDataArray() {
        this.actionLocksRightsGridData.forEach(item => {
            item["GrNrText"] = this.grNrData.find(t => t.Value === item["GrNr"]).Text;
            item["OgrNrText"] = this.ogrNrData.find(t => t.Value === item["OgrNr"]).Text;
        });
    }

    
    private actionLocksRightsSelectionChanged = (dataItem) => {
        if (!this.actionLocksRightsGridRef)
            return;
        const id = Helper.hasValue(dataItem) ? dataItem.Id : null;
        this.setState({ selectedActionRightsId: id });
    }

    private actionLocksSelectionChanged = async (dataItem) => {
        if (!this.actionLocksGridRef)
            return;

        const id = Helper.hasValue(dataItem) ? dataItem.Id : null;
        let rid = null;
        if (id == null) {
            this.actionLocksRightsGridData = [];
        }
        else {
            await this.getActionLocksRightsGridData(id);
            if (this.actionLocksRightsGridData.length > 0) {
                rid = this.actionLocksRightsGridData[0]["Id"]
            }
        }
        
        this.setState({selectedActionId: id, selectedActionRightsId: rid}, 
            () => {
                this.actionLocksRightsGridRef.selectRow(rid);
        });
    }
    
    private handleClickStandardButton = (type: ToolBarStandardButtonType) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.openEditSheet(null).then(() => {});
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.openEditSheet(this.state.selectedActionId).then(() => {});
        } else if (type === ToolBarStandardButtonType.DELETE) {
            this.removeActionLocks(this.state.selectedActionId).then(() => {});
        }
    }

    private handleClickCustomButton = async () => {
        const selectedId = this.state.selectedActionId;
        const result = await HTTPService.post<JsonResultClass>("ActionLocks/ToggleActionLocks", { id: selectedId });
        if (result.Code == 0) {
            await this.refresh();
            let row = this.actionLocksGridData.filter(x => x.Id == selectedId);
            this.setState({}, () => {
                this.actionLocksGridRef.selectRow(row[0]["Id"]);
            });
        }
        else
            NotificationHelper.showErrorMessage(this.translations["Standard.UnerwarteterFehler"]);
    }

    private openEditSheet = async (id: any) => {
        let idSaved = id;
        const url = Helper.hasValue(id) ? ("ActionLocks/EditActionLocks/" + id) : "ActionLocks/NewActionLocks";
        
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.bind(SheetEventType.SavedSuccessfully, async () => {
            let actionRightsIdToSelect = this.state.selectedActionRightsId;
            if (!idSaved) {
                //get new id
                const url = new URL(window.location.href);
                idSaved = url.searchParams.get("id");
                this.actionLocksRightsGridData = [];
                actionRightsIdToSelect = null;
            }
            
            await this.refresh();
            const row = this.actionLocksGridData.filter(x => x.Id == idSaved);
            this.setState({selectedActionId: idSaved, selectedActionRightsId: actionRightsIdToSelect}, () => {
                this.actionLocksGridRef.selectRow(row[0]["Id"]);
            }); 
        });
        
        sheet.bind(SheetEventType.Close, () => {
            this.setState({}, () => {
                this.actionLocksGridRef.selectRow(this.state.selectedActionId);
            })
        });
        
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    private removeActionLocks = async (id: any) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (!isOk)
            return;

        const result = await HTTPService.post<JsonResultClass>("ActionLocks/DeleteActionLocks", { id: id });
        if (result.Code == 0) {
            await this.refresh();
            if (this.actionLocksGridData.length == 0) {
                this.actionLocksRightsGridData = [];
                this.setState({selectedActionId: null, selectedActionRightsId: null});
            }
            else {
                let rrowId = null;
                const row = this.actionLocksGridData[0];
                if (row != null) {
                    await this.getActionLocksRightsGridData(row.Id);
                    if (this.actionLocksRightsGridData.length > 0) {
                        rrowId = this.actionLocksRightsGridData[0].Id;
                    }
                }
                this.setState({selectedActionId: row.Id, selectedActionRightsId: rrowId}, () => {
                    this.actionLocksGridRef.selectRow(row.Id);
                    this.actionLocksRightsGridRef.selectRow(rrowId);
                });
            }
        } else
            NotificationHelper.showErrorMessage(this.translations["WebSMS.Locks.DeleteError"]);
    }


    private handleClickStandardRightsButton = (type: ToolBarStandardButtonType) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.openEditSheetRights(null);
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.openEditSheetRights(this.state.selectedActionRightsId);
        } else if (type === ToolBarStandardButtonType.DELETE) {
            this.removeActionLocksRights(this.state.selectedActionRightsId).then(() => {});
        }
    }
    
    //Rights

    private openEditSheetRights = (id: any) => {
        let idSaved = id;
        const url = Helper.hasValue(id) ? ("ActionLocks/EditActionLocksRights/" + id) : 
            "ActionLocks/NewActionLocksRights?aktionId=" + this.state.selectedActionId;

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.bind(SheetEventType.SavedSuccessfully, async () => {
            if (!idSaved) {
                //get new id
                const url = new URL(window.location.href);
                idSaved = url.searchParams.get("id");
            }

            await this.getActionLocksRightsGridData(this.state.selectedActionId);
            
            const row = this.actionLocksRightsGridData.filter(x => x.Id == idSaved);
            this.setState({selectedActionRightsId: idSaved}, () => {
                this.actionLocksRightsGridRef.selectRow(row[0]["Id"]);
            });
        });

        sheet.bind(SheetEventType.Close, () => {
            this.setState({}, () => {
                this.actionLocksRightsGridRef.selectRow(this.state.selectedActionRightsId);
            })
        });

        General.Functions.HistoryState.pushSheetState(sheet, url);
    }
    
    private removeActionLocksRights = async (selectedid) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (!isOk)
            return;
        
        const result = await HTTPService.post<JsonResultClass>("ActionLocks/DeleteActionLocksRights", { id: selectedid });
        if (result.Code == 0) {

            await this.getActionLocksRightsGridData(this.state.selectedActionId);
            
            if (this.actionLocksRightsGridData.length == 0)
                this.setState({selectedActionRightsId: null});
            else {
                const row = this.actionLocksRightsGridData[0];
                this.setState({selectedActionRightsId: row.Id}, () => {
                    this.actionLocksRightsGridRef.selectRow(row.Id);
                });
            }
        } else
            NotificationHelper.showErrorMessage(this.translations["WebSMS.Locks.DeleteError"]);
    }

    private handleClickCustomRightsButton = async () => {
        const selectedId = this.state.selectedActionRightsId;
        const result = await HTTPService.post<JsonResultClass>("ActionLocks/ToggleActionLocksRights", { id: selectedId });
        if (result.Code == 0)
        {
            await this.getActionLocksRightsGridData(this.state.selectedActionId);
            const row = this.actionLocksRightsGridData.filter(x => x.Id == selectedId);
            this.setState({}, () => {
                this.actionLocksRightsGridRef.selectRow(row[0]["Id"]);
            });
        }
        else 
            NotificationHelper.showErrorMessage(this.translations["Standard.UnerwarteterFehler"]);
    }

    // noinspection JSUnusedGlobalSymbols
    createGrids = () => {
        let actionLocksButtons: Array<ToolBarStandardButton> = [];

        const IsActive = this.state.selectedActionId != null 
            && this.actionLocksGridData.find(x => x.Id === this.state.selectedActionId) ? 
            this.actionLocksGridData.find(x => x.Id === this.state.selectedActionId)["Aktiv"] : false;
        const toolToggleButton: Array<GridCustomToolBarButton> = [
            {
                id: "toggle1",
                caption: !IsActive ? Config.translations.activate : Config.translations.deactivate,
                enabled: this.state.selectedActionId != null,
                iconClass: !IsActive ? "k-i-checkbox-checked" : "k-i-checkbox",
                autoEnabledOnRecordSelected: false
            }
        ];

        const IsActiveRights = this.state.selectedActionId != null 
            && this.state.selectedActionRightsId != null 
            && this.actionLocksRightsGridData.length > 0 
            && this.actionLocksRightsGridData.find(x => x.Id === this.state.selectedActionRightsId) ?
            this.actionLocksRightsGridData.find(x => x.Id === this.state.selectedActionRightsId)["Aktiv"] : false;
        const toolToggleButtonRights: Array<GridCustomToolBarButton> = [
            {
                id: "toggle2",
                caption: !IsActiveRights ? Config.translations.activate : Config.translations.deactivate,
                enabled: this.state.selectedActionRightsId != null,
                iconClass: !IsActiveRights ? "k-i-checkbox-checked" : "k-i-checkbox",
                autoEnabledOnRecordSelected: false
            }
        ];

        actionLocksButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: this.props.entity.RecordRight.CanWrite });
        actionLocksButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.props.entity.RecordRight.CanWrite });
        actionLocksButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.delete, enabled: this.props.entity.RecordRight.CanWrite });

        let actionLocksRightsButtons: Array<ToolBarStandardButton> = [];
        actionLocksRightsButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: this.state.selectedActionId != null });
        actionLocksRightsButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.props.entity.RecordRight.CanWrite });
        actionLocksRightsButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.delete, enabled: this.props.entity.RecordRight.CanWrite });
        
        return (
            <div className="flex-container">

                <Region title={this.translations["WebSMS.ActionLook.ActionLooks"]} flexContainer={true} displayFlex={true} >


                    <Grid data={this.actionLocksGridData} options={this.actionLocksGridOptions} id="actionLocksGrid"
                        onSelectionChanged={this.actionLocksSelectionChanged} ref={(r) => this.actionLocksGridRef = r}
                        standardButtons={actionLocksButtons} onClickStandardButton={this.handleClickStandardButton}
                        customButtons={toolToggleButton} onClickCustomButton={this.handleClickCustomButton}
                        selectFilter={this.state.selectedActionId}
                        selectFilterField="Id" />

                </Region>

                <br />

                <Region title={this.translations["WebSMS.ActionLook.Ausnahmen"]} flexContainer={true} displayFlex={true} >
                    <Grid data={this.actionLocksRightsGridData} options={this.actionLocksRightsGridOptions} id="actionLocksRightsGrid"
                        onSelectionChanged={this.actionLocksRightsSelectionChanged} ref={(r) => this.actionLocksRightsGridRef = r}
                        standardButtons={actionLocksRightsButtons} onClickStandardButton={this.handleClickStandardRightsButton}
                        customButtons={toolToggleButtonRights} onClickCustomButton={this.handleClickCustomRightsButton}
                        selectFilter={this.state.selectedActionRightsId}
                        selectFilterField="Id" />
                </Region>

            </div>
        );
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}


interface ActionLocksAppState {
    selectedActionId: string,
    selectedActionRightsId: string
}

